function checkWebp() {
  try {
    return (
      document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0
    )
  } catch (err) {
    return false
  }
}
exports.install = function(Vue) {
  Vue.prototype.$formatImg = function formatImg(path, w, h = w, type = 'webp') {
    try {
      if (!path) return ''
      if (checkWebp() && path.indexOf('?') === -1) {
        return `${path}?imageMogr2/format/${type}/thumbnail/${w}x${h}`
      }
      return path
    } catch (e) {
      return ''
    }
  }

  Vue.prototype.openWin = function(url = '') {
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.setAttribute('id', 'camnpr')
    document.body.appendChild(a)
    a.click()
  }
}
